import store from 'store2';

export const setItem = (key, value) => {
  store.session(key, value);
};

export const getItem = (key) => store.session(key);

export const removeItem = (key) => store.session.remove(key);
